import { type ReactNode } from 'react';
import type { Creator } from '@/types';
import { Button } from '@/components/ui/button';
import { AiBadgesRow } from '@/components/ai/badges';
import { ExpandableText } from '@/components/ui/expandable-text';
import { CollectorPill } from './ai-collector-pill';

export { CurrentCategoryLine } from './ai-appeal-current-category';

export function AppealRowHeader({ creator }: { creator: Creator }): ReactNode {
  return (
    <div className="flex flex-wrap items-center justify-between gap-sm">
      <div className="flex flex-col gap-1">
        <a
          href={`https://instagram.com/${creator.ig_username}`}
          target="_blank"
          rel="noreferrer"
          className="font-medium text-sm text-text-primary hover:underline"
        >
          @{creator.ig_username}
        </a>
        <CollectorPill creator={creator} />
      </div>
      <AiBadgesRow creator={creator} />
    </div>
  );
}

function ReasoningCell(p: { title: string; content: string }): ReactNode {
  return (
    <div>
      <p className="text-xs font-medium text-text-tertiary">{p.title}</p>
      <ExpandableText content={p.content} maxChars={300} />
    </div>
  );
}

export function ReasoningPair({ creator }: { creator: Creator }): ReactNode {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-sm">
      <ReasoningCell
        title="Razonamiento de la IA"
        content={creator.ai_reasoning}
      />
      <ReasoningCell
        title="Apelación del collector"
        content={creator.appeal_description}
      />
    </div>
  );
}

type DecisionProps = {
  onAccept: () => void;
  onStartReject: () => void;
  pending: boolean;
};

function RejectBtn(p: { onClick: () => void; disabled: boolean }): ReactNode {
  return (
    <Button variant="ghost" size="sm" onClick={p.onClick} disabled={p.disabled}>
      Rechazar apelación
    </Button>
  );
}

function AcceptBtn(p: { onClick: () => void; disabled: boolean }): ReactNode {
  return (
    <Button
      variant="primary"
      size="sm"
      onClick={p.onClick}
      disabled={p.disabled}
    >
      Aceptar y validar
    </Button>
  );
}

export function DecisionButtons(p: DecisionProps): ReactNode {
  return (
    <div className="flex flex-wrap items-center justify-end gap-sm">
      <RejectBtn onClick={p.onStartReject} disabled={p.pending} />
      <AcceptBtn onClick={p.onAccept} disabled={p.pending} />
    </div>
  );
}
